import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGooglelensComponent } from './simple-icons-googlelens.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGooglelensComponent ],
    exports:      [ SimpleIconsGooglelensComponent ],
    bootstrap:    []
})
export class SimpleIconsGooglelensModule {}
